module.exports = __webpack_public_path__ + "media/images/emblems/Vaz_Obervaz_wappen-d33e372fe3aeb710acf8d9b2d8014b0f.svg";